export default __webpack_public_path__ + "static/media/ainola_2.45bb46f3.jpg";